import { Tooltip } from "antd";
import styles from "./style.module.less";

export const InProgressDot = () => {
    return (
        <div className={styles.inProgressDot}>
            <Tooltip placement="top" title="In Progress">
                 <i className="ri-donut-chart-fill"></i>
            </Tooltip>
           
        </div>
    );
}